import { CircleUser, type LucideIcon, PlusCircle } from "lucide-react";

interface TabSection {
  id: string;
  label: string;
  path: string;
  icon: LucideIcon;
}

export const FIELD_LEAD_PATH = "/field-lead";

const PROFILE_PATH = "/preferences";

export const TAB_SECTIONS: TabSection[] = [
  { id: "field-lead", label: "Cargar", path: FIELD_LEAD_PATH, icon: PlusCircle },
  { id: "profile", label: "Yo", path: PROFILE_PATH, icon: CircleUser },
];

export function isTabPath(pathname: string): boolean {
  return TAB_SECTIONS.some(
    (section) => pathname === section.path || pathname.startsWith(`${section.path}/`),
  );
}
